<div class="context-top-buttons" *ngIf="!assetPageMode">
  <button
    appButton
    name="share"
    location="asset-context-menu"
    [hasIcon]="true"
    spacing="full"
    [verticalIcon]="true"
    height="1"
    color="hard-simple"
    (click)="openShare.emit(); onClose.emit()"
  >
    <app-svg src="/assets/icons/forward.svg"></app-svg>
    <span>{{ 'asset-context-share' | translate }}</span>
  </button>
  <button
    appButton
    name="download"
    location="asset-context-menu"
    [hasIcon]="true"
    spacing="full"
    [verticalIcon]="true"
    height="1"
    color="hard-simple"
    (click)="downloadAsset(); onClose.emit()"
    *ngIf="accessLevel === 'edit' || gallery.download_single_asset"
  >
    <app-svg src="/assets/icons/download.svg"></app-svg>
    <span>{{ 'asset-context-download' | translate }}</span>
  </button>
</div>
<div class="divider" *ngIf="!assetPageMode"></div>

<div class="button-menu">
  <ng-container *ngIf="assetPageMode && clientMode">
    <app-button-menu-item
      name="guest-profile"
      location="asset-context-menu"
      (onClick)="openGuestProfileDialog(); onClose.emit()"
      icon="user"
      [fullWidth]="true"
      data-test-id="asset-context-guest-profile"
    >
      {{ 'your-profile' | translate }}
    </app-button-menu-item>

    <app-button-menu-item
      name="logout"
      location="asset-context-menu"
      (onClick)="logout(); onClose.emit()"
      icon="logout"
      [fullWidth]="true"
      *ngIf="state.guestAuthToken && state.guest.email"
    >
      {{ 'logout' | translate }}
    </app-button-menu-item>
    <div class="divider"></div>
  </ng-container>

  <ng-container *ngIf="accessLevel === 'edit'">
    <label
      appButton
      name="upload-replacement"
      location="asset-context-menu"
      [hasIcon]="true"
      spacing="full"
      color="simple"
      shape="small"
      height="1"
      for="replace-upload"
    >
      <app-svg src="/assets/icons/upload.svg"></app-svg>
      <span>{{ 'asset-context-replace' | translate }}</span>
      <input
        type="file"
        id="replace-upload"
        #upload
        class="hidden-input"
        (change)="uploadAssetEvent($event.target)"
        accept="*"
      />
    </label>
    <app-button-menu-item
      name="set-as-cover"
      location="asset-context-menu"
      icon="height-medium"
      (click)="setAsCover()"
      [fullWidth]="true"
    >
      {{ 'asset-context-set-as-cover' | translate }}
    </app-button-menu-item>

    <app-button-menu-item
      name="toggle-watermark"
      location="asset-context-menu"
      icon="image-watermarking"
      *ngIf="gallery.watermark"
      (click)="toggleWatermark(); onClose.emit()"
      [fullWidth]="true"
    >
      <span *ngIf="asset.watermark_enabled && gallery.watermark">Hide Watermark</span>
      <span *ngIf="!asset.watermark_enabled && gallery.watermark">Add Watermark</span>
    </app-button-menu-item>

    <app-button-menu-item
      name="add-watermark"
      location="asset-context-menu"
      icon="image-watermarking"
      (click)="openWatermarkingSettings(); onClose.emit()"
      [fullWidth]="true"
      *ngIf="!gallery.watermark"
    >
      Add Watermark
      <app-pro-tag
        location="asset-context-menu"
        permission="asset.watermarking"
        *ngIf="'!asset.watermarking' | permissions : gallery"
        [noTop]="true"
      ></app-pro-tag>
    </app-button-menu-item>

    <div class="divider"></div>
  </ng-container>

  <a
    appButton
    name="report-asset"
    location="asset-context-menu"
    href="https://docs.google.com/forms/d/e/1FAIpQLSca1PTNCOWW6rGxkhxrT-VVV1sPJQE7KgcrVUeAnIO6_V_nyw/viewform?usp=pp_url&entry.365566898={{
      url
    }}"
    target="_blank"
    [hasIcon]="true"
    spacing="full"
    color="simple"
    shape="small"
    height="1"
    *ngIf="accessLevel !== 'edit'"
    (click)="onClose.emit()"
  >
    <app-svg src="/assets/icons/alert.svg"></app-svg>
    <span>{{ 'report-asset' | translate }}</span>
  </a>

  <app-button-menu-item
    name="move-asset"
    location="asset-context-menu"
    icon="move-out"
    *ngIf="accessLevel === 'edit' && !isGalleryGuest"
    (click)="moveAsset(); onClose.emit()"
    [fullWidth]="true"
  >
    Move/Copy to (
    <div class="grey-50">...</div>
    )
  </app-button-menu-item>

  <app-button-menu-item
    name="delete"
    location="asset-context-menu"
    icon="trash"
    color="simple-warn"
    data-test-id="delete-asset"
    (click)="deleteAsset(); onClose.emit()"
    [fullWidth]="true"
    *ngIf="accessLevel === 'edit'"
  >
    {{ 'asset-context-delete' | translate }}
  </app-button-menu-item>
</div>
